import { Tooltip } from './Tooltip';

const Chart = {
  Tooltip,
};

export default Chart;
